'use strict';

export default angular
  .module('maestro.filters.locationTypeDesc', [])

  .filter('locationTypeDesc', function(config) {
    return function(locationId) {
      let locationType = config.getLocationTypeById(locationId);
      return locationType ? locationType.name : '';
    };
  })

  .name;
